module.exports = __webpack_public_path__ + "img/metricas-inicial-min.b931a360.png";